// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jI0Fs0D4{height:38px;width:fit-content}`, "",{"version":3,"sources":["webpack://./src/fsd/shared/ui/PageSizeSelect/PageSizeSelect.module.scss"],"names":[],"mappings":"AAAA,UACE,WAAA,CACA,iBAAA","sourcesContent":[".select {\n  height: 38px;\n  width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `jI0Fs0D4`
};
export default ___CSS_LOADER_EXPORT___;
